import { ThemeOptions } from "@bronte/viewer-api/src/main";
import { SpotlightOffsetData } from "./types";

export const DefaultThemeOptions: ThemeOptions = {
  enableShowHide: true,
  fontSelector: "default",
  fontSize: 16,
  isAnnotationHide: false,
  isFitToPage: false,
  isFitToWidth: false,
  isHotspotsHide: false,
  lineSpacing: "default",
  sliderVal: 20.5,
  textTransform: "default",
  variantId: "default-variant-id", // Should be set after we get theme variants.
  continuousScroll: false,
};

export const FONT_OPTIONS = [
  {
    label: "Default",
    value: "default",
  },
  {
    label: "Verdana",
    value: "Verdana",
  },
  {
    label: "Arial",
    value: "Arial",
  },
  {
    label: "Times New Roman",
    value: "Times New Roman",
  },
  {
    label: "Sassoon Sans",
    value: "Sassoon Sans",
  },
];

export const AnnotationActions = {
  Add: "Add",
  Edit: "Edit",
  Delete: "Delete",
};

export const AnnotationTypes = {
  Highlight: "Highlight",
  FlashCard: "Flashcard",
};

export const AnnotationColors = {
  Yellow: "Yellow",
  Green: "Green",
  Pink: "Pink",
};

export const initialWordOffsetData: Array<SpotlightOffsetData> = [
  { startOffset: 0, length: 5 },
  { startOffset: 5, length: 5 },
  { startOffset: 10, length: 5 },
  { startOffset: 15, length: 5 },
  { startOffset: 20, length: 5 },
  { startOffset: 25, length: 5 },
  { startOffset: 30, length: 5 },
  { startOffset: 35, length: 5 },
  { startOffset: 40, length: 5 },
  { startOffset: 45, length: 5 },
  { startOffset: 50, length: 5 },
  { startOffset: 55, length: 5 },
  { startOffset: 60, length: 5 },
  { startOffset: 65, length: 5 },
  { startOffset: 70, length: 5 },
  { startOffset: 75, length: 5 },
];

export const initialSentenceOffsetData: SpotlightOffsetData = { startOffset: 0, length: 80 };

export interface PageNumber {
  screenId: string;
  dataId: string;
}
